import React, { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import PropTypes from 'prop-types';
import { TitleBar, IconCircle, IconClose, IconCheck, IconExpandCollapse, IconSelected, evenRowColor } from '../common/theme';
import { toTime, toTimeType } from '../../Utils';
import DateSelectorComp from '../common/DateSelectorComp';

const MainProgramTableComp = ({pageState}) => {    

    const titleRow = <TitleBar>
        <Col style={{textAlign: 'left'}} xs='4'><br/>Programs</Col>
        <Col xs='2'>Time<br/>Spent</Col>
        <Col xs='2'>Activities<br/>Mastered</Col>
        <Col xs='2'>Questions<br/>Attempted</Col>
        <Col xs='2'><br/>Score</Col>
    </TitleBar>;

    const [isAdminChecked,setIsAdminChecked] = useState(false);
    const [isUserCateg,setIsUserCateg] = useState(false);
    const [hasUserTeachAdminLessons,sethasUserTeachAdminLessons] = useState(false);

    useEffect(() => {
        const checkIfUserTable=()=>{
            if(pageState.processedProgramSummary.length > 0){
                if(pageState.processedProgramSummary[0].categ == 'User')
                    return true;
            }
            return false;
        };

        const checkIfHasAdminLessons=()=>(pageState.processedProgramSummary.filter(item=>(item.schoolID === item.authorID)).length>0);                
        const checkIfHasTeacherLessons=()=>(pageState.processedProgramSummary.filter(item=>(item.schoolID !== item.authorID)).length>0);        
        sethasUserTeachAdminLessons(checkIfUserTable() && checkIfHasAdminLessons() && checkIfHasTeacherLessons());
        setIsUserCateg(checkIfUserTable());
    });    

    const onChangeHandler=(event)=>{
        setIsAdminChecked(event.target.checked);
    };

    const filterAdmin=(item)=>{
        if(pageState.isAdmin && isAdminChecked) return (item.schoolID === item.authorID);
        if(!pageState.isAdmin && isAdminChecked) return (item.schoolID !== item.authorID);
        return true;
    };

    return (
        <Container>
            <DateSelectorComp pageState={pageState}/> <br/>
            {hasUserTeachAdminLessons && <><input type="checkbox" onChange={(e)=>onChangeHandler(e)} checked={isAdminChecked}/> {pageState.isAdmin ? <>Hide Teacher Lists</> :<> Hide Shared Lists</>} </>}
            {titleRow}
            {pageState.processedProgramSummary.filter(item=>filterAdmin(item)).map((programRec, i) => 
                <ProgramRow key={i} index={i} programState={programRec} pageState={pageState}/>
            )}
            <br/>
        </Container>
    );
};

MainProgramTableComp.propTypes = {
    data: PropTypes.object
};

const ProgramRow = ({pageState, programState, index}) => {
    let {id, title, students , showStudents, timeSpent, TimesMastered, QuestionsRight, QuestionsAttempted, score} = programState;  

    const showStudentsComp = (programID) => {
        let nextState = [...pageState.processedProgramSummary];
        nextState = nextState.map(el => {el.showStudents = false; return el;}); // remove accidents
        let index = nextState.findIndex(el => el.id === programID);
        nextState[index] = {...nextState[index], showStudents: true};
        pageState.setProcessedProgramSummary(nextState);
        let productionPath ='';        
        if(pageState.programs[programID].productionPath){
            productionPath = pageState.programs[programID].productionPath;
            sessionStorage.setItem('productionPath',productionPath);  // change the productionPath depending on the program choosen
        } 
        pageState.setSelectedProgram({id:programID, name:pageState.programs[programID].title, productionPath});
    };
    
    const selectedStyle = () =>{
        let style = {cursor: 'pointer'};
        style['background'] = (index%2==0)?evenRowColor:'FFFFFF';
        return style;
    };

    const WordList=()=>{
        // console.log({programState});
        if(programState.Description){
            return <>
                <div style={{ color:'black', paddingBottom:'20px' }}>({programState.Description})</div>
            </>;
        }
        return <></>;            
    };

    return (
    <>
        <Row onClick={() => showStudentsComp(id)} style={selectedStyle()}>
            <Col xs='4' style={{color:'blue',textDecoration:'underline'}}> {title}  <WordList></WordList> </Col>
            <Col style={{textAlign: 'center'}} xs='2'>{toTime(timeSpent)} {toTimeType(timeSpent)}</Col>
            <Col style={{textAlign: 'center'}} xs='2'>{TimesMastered}</Col>
            <Col style={{textAlign: 'center'}} xs='2'>{QuestionsRight} / {QuestionsAttempted}</Col>
            <Col style={{textAlign: 'center'}} xs='2'>{score}{score!=='--' && <>%</>}</Col>
        </Row>

    </>
    );
};

export default MainProgramTableComp;